<template>
    <div>

        <template v-if="pagina=='buscar'">
            <div class="row">
                <div class="col">
                    <p>Digite o seu endereço:</p>
                </div>
            </div>

            <div class="form-group row">
                <div class="col">
                    <input
                        placeholder="Endereço"
                        type="text"
                        name="bairro"
                        id="address"
                        v-model="address"
                        @input="autocompleteAddress"
                        class="form-control form-control-lg"
                    >

                    <div v-if="showSuggestions">
                        <ul>
                            <li v-for="suggestion in suggestions" :key="suggestion.place_id" @click="selectAddress(suggestion)">
                                <a href="#">{{ suggestion.description }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

        </template>

        <div v-show="marker != null" class="text-center">
            <div id="map"></div>
            <p>{{ address }}</p>
            <br><br>
            <a class="btn btn-lg b-btn " role="button" v-on:click="$emit('map-endereco', endereco)"> Continuar </a>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        tipo: String,
    },

    data() {
        return {

            pagina: this.tipo,

            map: null,
            address: '',
            geocoder: null,
            autocompleteService: null,
            suggestions: [],
            showSuggestions: false,
            marker: null,
            endereco: {
                cep: "",
                pais: "",
                estado: "",
                uf: "",
                cidade: "",
                bairro: "",
                rua: "",
                lat: "",
                lng: "",
                place_id: "",
                numero:"",
            }
        };
    },
    mounted() {
        this.initMap();
        this.geocoder = new google.maps.Geocoder();
        this.autocompleteService = new google.maps.places.AutocompleteService();

        if (this.tipo=='minha_licalização') {
            this.getCurrentLocation();
        }
    },
    methods: {
        //Iniciar Mapa
        initMap() {
            this.map = new google.maps.Map(document.getElementById("map"), {
                zoom: 18,
                center: { lat: -34.397, lng: 150.644 },
                mapId: "DEMO_MAP_ID",
            });
        },

        //Alterar a posição do marcador manualmente
        handleMarkerDrag() {
            console.log("entrou");
            const newPosition = this.marker.getPosition();

            const pos = {
                    lat: newPosition.lat(),
                    lng: newPosition.lng(),
                };

            this.getAddressFromCoordinates(pos.lat, pos.lng);

            console.log('Nova posição:', newPosition.lat(), newPosition.lng());
            // Aqui você pode realizar qualquer ação com a nova posição do marcador
        },
        //Pega a localização atual
        getCurrentLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    this.map.setCenter(pos);

                    if (this.marker != null) {
                        this.marker.setPosition(pos);
                    }else{
                        this.marker = new google.maps.Marker({
                            position: pos,
                            map: this.map,
                            draggable: true,
                            title: "Sua localização atual",
                        });
                    }


                    this.getAddressFromCoordinates(pos.lat, pos.lng);

                    google.maps.event.addListener(this.marker, 'dragend', () => {
                        this.handleMarkerDrag();
                    });
                });
            }
        },
        //Pega o endereço pelas coodernadas fornecidas
        getAddressFromCoordinates(lat, lng) {
            const latlng = { lat, lng };
            this.geocoder.geocode({ location: latlng }, (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        this.address = results[0].formatted_address;
                        this.preecherEndereco(results);
                    } else {
                    console.error("Nenhum resultado encontrado");
                    }
                } else {
                    console.error("Geocoder falhou devido a: " + status);
                }
            });
        },

        //Autocomplete
        autocompleteAddress() {
        if (this.address === '') {
            this.showSuggestions = false;
            return;
        }

        this.autocompleteService.getPlacePredictions({ input: this.address, region: "br", types: ['route'] }, (predictions, status) => {
                if (status === 'OK') {
                this.suggestions = predictions;
                this.showSuggestions = true;
                } else {
                console.error("Autocomplete falhou devido a: " + status);
                }
            });
        },

        preecherEndereco(results) {

            console.log(results);

            this.endereco.lat = results[0].geometry.location.lat();
            this.endereco.lng = results[0].geometry.location.lng();
            this.endereco.place_id = results[0].place_id;

            results[0].address_components.forEach(element => {

                element.types.forEach(element2 => {
                    switch (element2) {
                        case 'route':
                            this.endereco.rua = element.long_name;
                            break;
                        case 'street_number':
                            this.endereco.numero = element.long_name;
                            break;
                        case 'sublocality':
                            this.endereco.bairro = element.long_name;
                            break;
                        case 'administrative_area_level_2':
                            this.endereco.cidade = element.long_name;
                            break;
                        case 'administrative_area_level_1':
                            this.endereco.estado = element.long_name;
                            this.endereco.uf = element.short_name;
                            break;
                        case 'country':
                            this.endereco.pais = element.long_name;
                            break;
                        case 'postal_code':
                            this.endereco.cep = element.long_name;
                            break;

                        default:
                            break;
                    }
                });

            });

        },

        //Seleciona um endereço da lista de sugestões
        selectAddress(suggestion) {
            this.address = suggestion.description;
            this.showSuggestions = false;

            // Use Geocodificação para obter coordenadas do endereço selecionado e atualizar o mapa
            this.geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
                if (status === 'OK') {

                    this.preecherEndereco(results);

                    const location = results[0].geometry.location;
                    this.map.setCenter(location);

                    if (this.marker != null) {
                        this.marker.setPosition(location);
                    }else{
                        this.marker = new google.maps.Marker({
                            position: location,
                            map: this.map,
                            draggable: true,
                            title: suggestion.description,
                        });
                    }

                    google.maps.event.addListener(this.marker, 'dragend', () => {
                        this.handleMarkerDrag();
                    });

                } else {
                    console.error("Geocoder falhou devido a: " + status);
                }
            });
        },
    }
}
</script>

<style scoped>


ul {
    list-style-type: none; /* Remove os marcadores */
    padding: 0;
    margin: 0;
    background-color: #f0f0f0;
}


ul li a {
    display: block;
    color: #000;
    padding: 12px 16px;
    text-decoration: none;
}

ul li a:hover {
    color: #fff;
    background-color: #575757; /* Muda a cor ao passar o mouse */
}

</style>
